<template>
    <div>

        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- System Details -->
        <template v-if="formatted">
            <sau-service-common-system :service="service" class="pt-6"></sau-service-common-system>
        </template>

        <!-- Performance Metrics -->
        <sau-vps-xs-metrics :service="service" class="pt-6"></sau-vps-xs-metrics>

    </div>
</template>

<script>
import VpsMetrics from './_Metrics';
export default {
    props: ['service'],
    components: {
        'sau-vps-xs-metrics': VpsMetrics
    },
    data() {
        return {
            formatted: false,
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() != 'suspended') {
            this.startApp();
        }
    },
    methods: {
        startApp() {
            this.getDeviceInfo().then(response => {
                if(response.data) {
                    Vue.set(this.service, 'custom', response.data);
                    this.formatted = true;
                }
            }).catch(error => {
                console.log('error', error);
            })
        },
    },
    computed: {
    }
}
</script>
